import { DashboardService, toastr, SUCCESS_REPONSE_CODE, UNPROCESSABLE_ENTITY_RESPONSE_CODE, handleOtherResponseCode,
		 REDIRECT, ErrorPages, CustomToastrAction, MergeRecordsService, CommonAction, CandidateMergeAction} from '@/imports-files/pages/clients/activities/index';


var calander_array;
export class ActivitiesAction
{
	constructor(setApiError, calanderData, setCalanderData, setActivitiesData, activitiesData, setConfirmation, setFlagForRerender, setOfferRejectReasons, router, setCalendarDataArray, setAgencyAcceptReject, setInfoModal)
	{
		this.errorPage         		=  new ErrorPages();
		this.setApiError 	   		=  setApiError;
		this.dashboardService  		=  new DashboardService();
		this.setCalanderData   		=  setCalanderData;
		calander_array 		   		=  calanderData;
		this.activitiesData     	=  activitiesData;
		this.setActivitiesData		=  setActivitiesData;
		this.customToastrAction 	=   new CustomToastrAction();
		this.setConfirmation		=	setConfirmation;
		this.mergeRecordsService	=	new MergeRecordsService()
		this.setFlagForRerender = setFlagForRerender
		this.setOfferRejectReasons = setOfferRejectReasons
		this.setInfoModal = setInfoModal
		this.router = router
		this.setCalendarDataArray = setCalendarDataArray
		this.setAgencyAcceptReject = setAgencyAcceptReject
		this.commonAction = new CommonAction();


		this.candidateMergeAction = new CandidateMergeAction({
	    setApiError: setApiError,
	    setFlagForRerender: setFlagForRerender,
	    router: router,
	    setAgencyAcceptReject: setAgencyAcceptReject,
	    activitiesData: activitiesData,
	    setActivitiesData: setActivitiesData
	  })
	}

	async getDashboardData(router)
	{
		const dashboard_result   =  await this.dashboardService.getDashboardData();
		const activity_result    =  await this.dashboardService.getActivityData();
		const status 			 =  this.errorPage.handleMultipleApiErrorCodes([dashboard_result?.request, activity_result?.request])
		let result 	    	 	 =  { dashboard_result: dashboard_result.data, activity_result: activity_result.data }
		this.setApiError(status)
		return result;
	}

	async getActivityScrollData(type, activitiesData, setActivitiesData, setFlagForRerender, pageNumber, setPageNumber)
	{
		var body = '';

		if(type == 'alerts')
		{
			body      =  {alerts_page: pageNumber+1}
		}
		else
		{
			body      =  {comms_page: pageNumber+1}
		}
		let result    =  await this.dashboardService.getScrollActivityData(body);
		this.setApiError(result.request);
		setPageNumber(pageNumber+1);

		if(type == 'alerts')
		{
			activitiesData.alerts = activitiesData.alerts.concat(result.data.data.alerts);
			setActivitiesData(activitiesData);
		}
		else
		{
			activitiesData.comms = activitiesData.comms.concat(result.data.data.comms);
			setActivitiesData(activitiesData);
		}

		setFlagForRerender(Math.random() * 10000);

	}

	async nextOnboardingStep(step, router)
	{
		const result 	  	= 	await this.dashboardService.updateOnboardingStep({current_step: step});
		this.setApiError(result.request)
		const status_code 	= 	result.status || result.response.status;

		switch (status_code)
		{
			case SUCCESS_REPONSE_CODE:
				let next_step 	= 	result.data.next_step
				let url 		= 	`${REDIRECT.client.quick_setup}${next_step}`;
				(next_step == 'complete') ? router.push(REDIRECT.client.activities) : router.push(url)
				break;
			default:
				handleOtherResponseCode(status_code, router)
		}
	}

	async dismissOnboarding(router, dashboardData, setDashboardData, setFlagForRerender)
	{
			const result = await this.dashboardService.dismiss();
			this.setApiError(result.request)
			const status_code = result.status || result.response.status;
			switch (status_code)
			{
				case SUCCESS_REPONSE_CODE:
					dashboardData.onboarding_dismissed = true
					await setDashboardData(dashboardData)
					setFlagForRerender(Math.random() * 10000);
					break;
				case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
					this.customToastrAction.setNormalToastr(result.response.data.error, 'warning');
					// toastr.warning(result.response.data.error)
				default:
					handleOtherResponseCode(status_code, router)
			}
	}

	previousWeek(event)
	{
		var container      		= 	document.querySelector('.SchedulingContainer');
		var header_element 		= 	container.childNodes[0];
		var scroll_direction  	=   'up';
		this.getCalanderData(scroll_direction, header_element);
	}

	nextWeek(event)
	{
		var container      		= 	document.querySelector('.SchedulingContainer');
		var header_element 		= 	container.childNodes[0];
		var scroll_direction  	=   'down';
		this.getCalanderData(scroll_direction, header_element);
	}


	setInitialArrowData(setCurrentWeek, currentWeek)
	{
		if( document.querySelector('#Current_Week') && !currentWeek)
		{
			var current_week 	   = 	document.querySelector('#Current_Week').closest('.Week');
			setCurrentWeek(current_week);
		}
	}


	  pagination(event)
	  {
		var element 		  	=   event.target;
		if (element.scrollHeight - element.scrollTop === element.clientHeight)
		{
			var container      		= 	document.querySelector('.SchedulingContainer');
			var header_element 		= 	container.childNodes[container.childNodes.length - 1];
			var scroll_element 		= 	container.childNodes[container.childNodes.length - 3];
			var scroll_direction  	=   'down';

			this.getCalanderData(scroll_direction, header_element, container, scroll_element);


		}
		else if ( element.scrollTop == 0 )
		{
			var container      		= 	document.querySelector('.SchedulingContainer');
			var header_element 		= 	container.childNodes[0];
			var scroll_element 		= 	container.childNodes[2];
			var scroll_direction  	=   'up';
			this.getCalanderData(scroll_direction, header_element, container, scroll_element);
		}

  	  }


	getCalanderData(direction, element)
	{
		var week_year = element.getAttribute('id').split('_');
		var body 	  =  ''
		if(direction == 'up')
		{
			var week =  parseInt(week_year[0]) - 1 == 0 ? 52 : parseInt(week_year[0]) - 1;
			var year =  parseInt(week_year[0]) - 1 == 0 ? parseInt(week_year[1]) - 1 :  parseInt(week_year[1])  ;
			body = {week: week, year: year, scroll: direction};
		}
		else
		{
			var week =  parseInt(week_year[0]) + 1 == 53 ? 1 : parseInt(week_year[0]) + 1;
			var year =  parseInt(week_year[0]) + 1 == 53 ? parseInt(week_year[1]) + 1 :  parseInt(week_year[1])  ;
			body = {week: week, year: year, scroll: direction};
		}

		var k_this = this;
		this.dashboardService.getEventData(body).then(result => {
																	calander_array = result.data.data.events.data;
																	k_this.setCalanderData(calander_array)
																	let calendar_data_array = result.data.data.events.date_range_array;
																	k_this.setCalendarDataArray(calendar_data_array)
																});
	}

	getCalanderDateData(calanderHash)
	{
		var week_year  =  element.getAttribute('id').split('_');
		var body 	     =  calanderHash;
		var k_this 		 =  this;
		this.dashboardService.getEventData(body).then(result => {
																	calander_array = result.data.data.events.data;
																	k_this.setCalanderData(calander_array)
																	let calendar_data_array = result.data.data.events.date_range_array;
																	k_this.setCalendarDataArray(calendar_data_array)
																});
	}

	async dismissNotification(current_element, type, setFlagForRerender, setConfirmation)
	{
		var body = {};
		if(type == 'comms' || type == 'alerts')
		{
			body.all =  type;
		}
		else
		{
			if(type == 'comm_id')
			{
				body.id = current_element.classList.contains('Cross') ? current_element.getAttribute('data-comm_id') : current_element.closest('svg').getAttribute('data-comm_id') ;
			}
			else
			{
				body.id = current_element.classList.contains('Cross') ? current_element.getAttribute('data-alert_id') : current_element.closest('svg').getAttribute('data-alert_id') ;
			}
		}

		let result = await this.dashboardService.dismissNotification(body);
		this.setApiError(result.request);
		const status_code 	= 	result.status || result.response.status;

		switch (status_code)
		{
			case SUCCESS_REPONSE_CODE:  if(type != 'comms' && type != 'alerts')
										{
											var element =  current_element.closest('.NotificationSection__List');
											element.style.display = 'none';
											setConfirmation(false);
										}
										else
										{
											var activitiesData   = this.activitiesData;
											activitiesData[type] = [];
											this.setActivitiesData(activitiesData);
											setConfirmation(false);
											setFlagForRerender(Math.random() * 10000);
										}
			default: '';
		}

	}

	async nextStep(data, params)
	{

		if(data.href && data.href != '')
		{
			window.open(data.href, "");
		}
		if(data.details){
			let modal_name = data.details.modal_name
			switch(modal_name){
				case 'reject_offer_reason':
					var result    =  await this.dashboardService.getOfferRejectedReason(data.details);
					this.setApiError(result.request);
					let result_data = result.data
					result_data.state = true
					params.setOfferRejectReasons(result_data)
					break;
				case 'reject_job_reason':
					result    =  await this.dashboardService.getOfferRejectedReason(data.details);
					this.setApiError(result.request);
					result_data = result.data
					result_data.state = true
					this.setOfferRejectReasons(result_data)
					break;
				case 'job_approval_user_rejected_response':
					result_data = data.details.reason
					this.setOfferRejectReasons({state: true, heading: 'Rejection Reason', reasons: data.details.reason, job_status: 'Rejected'})
					// this.setInfoModal({state: true, heading: 'Rejection Reason', message: data.details.reasons, job_status: 'Rejected'})
					break;
				case 'job_approval_rejected_response':
					this.setInfoModal({state: true, heading: 'Rejection Reasons', message: data.details.reasons, job_status: 'Rejected'})
					// this.setInfoModal({state: true, heading: 'Rejection Reason', message: data.details.reasons, job_status: 'Rejected'})
					break;
				case 'job_approval_user_approved_response_received':
					result_data = data.details
					this.setInfoModal({state: true, heading: 'Approver', message: result_data.message, job_status: ''})
					// this.setInfoModal({state: true, heading: 'Rejection Reason', message: data.details.reasons, job_status: 'Rejected'})
					break;

				default:
					data.details.show_accept_reject ? this.candidateMergeAction.showAcceptReject(data) : '';
			}
		}
	}

	getMyInterviewData(event, calendarHash)
	{
		this.setTabActive(event);
		let body 	     				=  {};
		body['current_date']	=	 this.commonAction.getParamsToUrlWithoutRouter('current_date') ? this.commonAction.getParamsToUrlWithoutRouter('current_date') : this.commonAction.getDateInDMYFormat(new Date());
		body['selected_tab']	=	 this.commonAction.getParamsToUrlWithoutRouter('selected_tab') ? this.commonAction.getParamsToUrlWithoutRouter('selected_tab') : 'month';
		body['is_my_interviews'] = true;
		body 	     =  {activities: body};

		let k_this 		 =  this;

		calendarHash['selected_tab'] = 'month';
		calendarHash['current_date'] = this.commonAction.getParamsToUrlWithoutRouter('current_date') ? this.commonAction.getParamsToUrlWithoutRouter('current_date') : this.commonAction.getDateInDMYFormat(new Date());
		calendarHash['is_my_interviews'] = true

		this.commonAction.paramsToUrlWithoutRouter(calendarHash, this.router);
		this.dashboardService.getEventData(body).then((result) => {
																	calander_array = result.data.data.events.data;
																	k_this.setCalanderData(calander_array)
																	let calendar_data_array = result.data.data.events.date_range_array;
																	k_this.setCalendarDataArray(calendar_data_array)
																});
	}

	getTeamInterviewData(event, calendarHash)
	{
		this.setTabActive(event);
		let body 	     				=  {};
		body['current_date']	=	 this.commonAction.getParamsToUrlWithoutRouter('current_date') ? this.commonAction.getParamsToUrlWithoutRouter('current_date') : this.commonAction.getDateInDMYFormat(new Date());
		body['selected_tab']	=	 this.commonAction.getParamsToUrlWithoutRouter('selected_tab') ? this.commonAction.getParamsToUrlWithoutRouter('selected_tab') : 'month';
		body['is_my_interviews'] = false;
		body 	     =  {activities: body};
		let k_this 		 =  this;
		calendarHash['selected_tab'] = 'month';
		calendarHash['current_date'] = this.commonAction.getParamsToUrlWithoutRouter('current_date') ? this.commonAction.getParamsToUrlWithoutRouter('current_date') : this.commonAction.getDateInDMYFormat(new Date());
		calendarHash['is_my_interviews'] = false
		this.commonAction.paramsToUrlWithoutRouter(calendarHash, this.router);
		this.dashboardService.getEventData(body).then((result) => {
																	calander_array = result.data.data.events.data;
																	k_this.setCalanderData(calander_array)
																	let calendar_data_array = result.data.data.events.date_range_array;
																	k_this.setCalendarDataArray(calendar_data_array)
																});
	}

	setTabActive(event)
	{
		let all_tab = document.querySelectorAll('.ReactInterviewTypeTab');
		for(let element of all_tab )
		{
				element.classList.remove('TabActiveUnderline');
		}
		event.target.classList.add('TabActiveUnderline');
	}

	onSelectTab(setTabIndex, tabIndex, calendarHash, setTodayClick)
 {
	 setTabIndex(tabIndex);
	 setTodayClick(false);
	 calendarHash.current_date = this.commonAction.getDateInDMYFormat(calendarHash.current_date);
	 switch(tabIndex)
	 {
		 case 0:calendarHash.selected_tab = 'day';
								 break;
		 case 1: calendarHash.selected_tab = 'week';
								 break;
		 case 2:calendarHash.selected_tab = 'month';
									break;
		 default: calendarHash.selected_tab = 'month';
  }

	 this.commonAction.paramsToUrlWithoutRouter(calendarHash, this.router);
 }
}
